document.addEventListener('DOMContentLoaded', function () {
  const quantityInput = document.querySelector('input[name="quantity"]');

  // Detectar precios en oferta o regulares
  const priceSale = document.querySelector('.price-item--sale');
  const priceRegular = document.querySelector('.price-item--regular');

  // Usar el primero que exista
  const priceEl = priceSale || priceRegular;
  if (!quantityInput || !priceEl) return;

  // Extraer valor numérico del texto
  const extractPrice = (text) => {
    return parseFloat(text.replace(/[^\d,]/g, '').replace(',', '.'));
  };

  const unitPrice = extractPrice(priceEl.textContent);

  // Formatear como pesos colombianos
  const formatCOP = (value) => {
    return '$' + value.toLocaleString('es-CO') + ' COP';
  };

  const updatePrice = () => {
    const qty = parseInt(quantityInput.value) || 1;
    const total = unitPrice * qty;

    // Actualizar solo el precio visible (no el tachado)
    if (priceSale) {
      priceSale.textContent = formatCOP(total);
    } else if (priceRegular) {
      priceRegular.textContent = formatCOP(total);
    }
  };

  quantityInput.addEventListener('input', updatePrice);
  quantityInput.addEventListener('change', updatePrice);

  // Observar cambios forzados (ej. por botones de cantidad)
  const observer = new MutationObserver(updatePrice);
  observer.observe(quantityInput, { attributes: true });

  // Ejecutar la primera actualización
  updatePrice();
});
